export const MODAL_WIZARD_BUTTON_TYPE = {
  NEXT: 'next',
  PREV: 'prev',
  CANCEL: 'cancel',
  SUBMIT: 'submit',
} as const;

export type MODAL_WIZARD_BUTTON_TYPE = typeof MODAL_WIZARD_BUTTON_TYPE;
export type A_MODAL_WIZARD_BUTTON_TYPE = MODAL_WIZARD_BUTTON_TYPE[keyof MODAL_WIZARD_BUTTON_TYPE];
